// @flow
/* eslint-disable */
import React, { useEffect } from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';
import { Card } from '../../components';
import { P } from '../../components/Typography';
import Preloader from '../../components/Preloader';
import useWindowDimensions from '../../utils/windowDemensions';
import { getBreakpoints, MATRIX as matrixBreakpoints } from '../../utils/breakpoints';

const cards = [
  'A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2',
];

type Props = {
  setSelectedTable: (number) => void,
  onSetCard1: (string) => void,
  onSetCard2: (string) => void,
  onSetSuit: (string) => void,
  setSuitQuality: (string) => void,
  setTable: () => void,
  selectedStake: string,
  firstPairCardTableFold: Array<any>,
  setFirstPairCardTableFold: () => void,
  isFirstPairCardTableFoldLoaded: boolean,
  easyRFI?: boolean,
  isPlo5: boolean,
  isFirstPairSelector: boolean,
  selectedCards: string,
  isDoublesuit?: boolean,
  smartRange?: boolean,
  setShowPercents: () => void,
}

const CardTable = ({
                     setSelectedTable,
                     setTable,
                     onSetCard1,
                     onSetCard2,
                     onSetSuit,
                     setSuitQuality,
                     selectedStake,
                     setFirstPairCardTableFold,
                     firstPairCardTableFold,
                     isFirstPairCardTableFoldLoaded,
                     easyRFI,
                     isPlo5,
                     isFirstPairSelector,
                     selectedCards,
                     isDoublesuit,
                     smartRange,
                     setShowPercents
                   }: Props) => {
  const handleClick = (num, card, suit) => {
    // TO DO: refactor below
    setShowPercents(false);
    if (isFirstPairSelector && isPlo5) {
      setSelectedTable(num);
      onSetCard1(card[0]);
      onSetCard2(card[1]);
      onSetSuit(suit);
    } else if (isFirstPairSelector && !isPlo5) {
      setSelectedTable(num);
      onSetCard1(card[0]);
      onSetCard2(card[1]);
      onSetSuit(suit);
      setTable();
    } else if (!isFirstPairSelector && isPlo5) {
      setSelectedTable(4)
      onSetCard1(card[0]);
      onSetCard2(card[1]);
      setSuitQuality(suit);
      setTable();
    }
  };

  const colorCellSelector = (x, y) => {
    if (firstPairCardTableFold && firstPairCardTableFold.length) {
      const searchedCell = firstPairCardTableFold.filter((cell) => cell.y === x + 1 && cell.x === y + 1);
      if (searchedCell.length) {
        return searchedCell[0].color;
      }
    }
    return '';
  };
  const colorTextSelector = (x, y) => {
    if (colorCellSelector(x, y) === 'rgb(39, 51, 57)' || colorCellSelector(x, y) === '#262F39') {
      return styles.whiteText;
    }
    return styles.blackText;
  };
  const setCards = (x, indexX, y, indexY) => {
    const targetTable = (isPlo5 && isFirstPairSelector) ? 3 : 4;
    if (x === y && isFirstPairSelector) {
      return (
        <div
          className={classnames(styles.redBlue,
            colorCellSelector(indexX, indexY).includes('rgb(39, 51, 57)') ? styles.whiteTextTriangle : '')}
          style={{ background: colorCellSelector(indexX, indexY) }}
        >
          {`${x}${y}`}
          {/* eslint-disable-next-line max-len */}
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div
            className={classnames(styles.sameBlue)}
            onClick={() => handleClick(targetTable, `${x}${y}`, 'single')}
          />
          {/* eslint-disable-next-line max-len */}
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div
            className={classnames(styles.sameRed)}
            onClick={() => handleClick(targetTable, `${x}${y}`, 'double')}
          />
        </div>
      );
    }

    if ((indexX > 10 || indexY > 10) && (!isPlo5)) {
      return (
        <div className={styles.impossible}>
          {`${indexX > indexY ? `${y}${x}` : `${x}${y}`}`}
        </div>
      );
    }

    if (isPlo5 && isFirstPairSelector && (indexX > 9 || indexY > 9)) {
      return (
        <div className={styles.impossible}>
          {`${indexX > indexY ? `${y}${x}` : `${x}${y}`}`}
        </div>
      );
    }

    // if (isPlo5 && !isFirstPairSelector && (indexX > 11 || indexY > 11)) {
    //   return (
    //     <div className={styles.impossible}>
    //       {`${indexX > indexY ? `${y}${x}` : `${x}${y}`}`}
    //     </div>
    //   );
    // }

    if (isPlo5 && !isFirstPairSelector && firstPairCardTableFold && firstPairCardTableFold.length) {
      const searchedCell = firstPairCardTableFold.filter((cell) => cell.y === indexX + 1 && cell.x === indexY + 1);
      if (searchedCell.length && x === y) {
        return (
          <div
            className={classnames(styles.redBlue,
              colorCellSelector(indexX, indexY).includes('rgb(39, 51, 57)') ? styles.whiteTextTriangle : '')}
            style={{ background: colorCellSelector(indexX, indexY) }}
          >
            {`${x}${y}`}
            {/* eslint-disable-next-line max-len */}
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            {
              (x === 'A' && y === 'A') ?
                <div
                  className={classnames(styles.sameBlue, styles.sameImpossible)}
                /> : <div
                className={classnames(styles.sameBlue)}
                onClick={() => handleClick(targetTable, `${x}${y}`, 'single')}
              />
            }

            {/* eslint-disable-next-line max-len */}
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div
              className={classnames(styles.sameRed)}
              onClick={() => handleClick(targetTable, `${x}${y}`, 'double')}
            />
          </div>
        );
      }
      if (!searchedCell.length) {
        return (
          <div className={styles.impossible}>
            {`${indexX > indexY ? `${y}${x}` : `${x}${y}`}`}
          </div>
        );
      }
    }

    if (indexX > indexY) {
      return (
        <button
          type="button"
          onClick={() => handleClick(targetTable, `${y}${x}`, 'double')}
        >
          {`${y}${x}`}
        </button>
      );
    }
    return (
      <button
        type="button"
        onClick={() => handleClick(targetTable, `${x}${y}`, 'single')}
      >
        {`${x}${y}`}
      </button>
    );
  };

  useEffect(() => {
    setFirstPairCardTableFold(easyRFI, smartRange);
  }, []);

  useEffect(() => {
    setFirstPairCardTableFold(easyRFI, smartRange);
  }, [easyRFI, smartRange]);

  const { width, height } = useWindowDimensions();

  const getLabelName = (isLeft) => {
    if (isLeft) {
      if (isPlo5 && !isFirstPairSelector) {
        return 'BAD SUITED'
      }
      return 'SINGLE SUITED'
    } else {
      if (isPlo5 && !isFirstPairSelector) {
        return 'GOOD SUITED'
      }
      return 'DOUBLE SUITED'
    }
  }

  return (
    <Preloader isLoading={isFirstPairCardTableFoldLoaded}>
      <div
        // style={{
        //   height: `${getBreakpoints(matrixBreakpoints, 'height', width)
        //   * getBreakpoints(matrixBreakpoints, 'scale', width)}px`,
        // }}
        style={{ transform: `scale(${getBreakpoints(matrixBreakpoints, 'scale', width)})`,
          height: `${width < 500 ? `${height * getBreakpoints(matrixBreakpoints, 'scale', width)}px` : 'auto'}`
          // width: `${width < 500 ? `${width * 2}px` : 'auto'}`,
          }}
        className={styles.tableContainer}
      >
        <div
          className={styles.sideNotes}
        >
          <P style={{ color: '#73B6CB' }}>{getLabelName(true)}</P>
        </div>
        <Card
          // height={getBreakpoints(matrixBreakpoints, 'height', width)
          //       * getBreakpoints(matrixBreakpoints, 'scale', width)}
          use="transparent"
          className={styles.matrix}>
          <div className={styles.row}>
            <div className={classnames(styles.cell)}>
              {
                (isPlo5 && !isFirstPairSelector) ? <div className={styles.empty} style={{background: isDoublesuit ? '#FF1738' : '#73B6CB'}}>{selectedCards.slice(0, 2)}</div> :
                <div className={styles.empty}>{selectedStake.replace('rfi', '').toUpperCase().slice(0, 2)}</div>
              }
            </div>
            {cards.map((card) => (
              <div key={card} className={classnames(styles.cardLabel, styles.cell)}>{card}</div>))}
          </div>
          {cards.map((cardY, indexY) => (
            <div
              key={cardY}
              className={styles.row}
            >
              <div className={classnames(styles.cardLabel, styles.cell)}>
                {cards[indexY]}
              </div>
              {cards.map((cardX, indexX) => (
                <div
                  key={cardX}
                  className={classnames(styles.cell,
                    colorTextSelector(indexX, indexY),
                  )}
                  style={{
                    background: colorCellSelector(indexX, indexY),
                  }}
                >
                  {setCards(cardX, indexX, cardY, indexY)}
                </div>
              ))}
            </div>
          ))}
        </Card>
        <div
          className={styles.sideNotes}
        >
          <P style={{ color: '#FF5F5F' }}>{getLabelName(false)}</P>
        </div>
      </div>
    </Preloader>
  );
};

export default CardTable;
